import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import React from 'react';

export function YesNoDropdown(props) {
    const { state, setState, label } = props
    const handleChange = (event) => {
        if(label ==="Maguire"){
            setState({ ...state, maguireVal: event.target.value });
        } else if(label ==="InputSavings"){
            setState({ ...state, savingsIndicator: event.target.value });
        } else if(label ==="GHD"){
            setState({ ...state, anyGHGReduction: event.target.value });
        } 
        console.log(":: event.target.value ::", event.target.value)
    };

    const getStateValue=() => {
        if(label === "Maguire")
         return state.maguireVal 
         else if(label === "InputSavings")
         return state.savingsIndicator
         else if(label === "GHD")
         return state.anyGHGReduction
    }
    return (
        <FormControl>
        <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={getStateValue()}
            sx={{ maxWidth: '70px' }}
            displayEmpty
            onChange={handleChange}
            inputProps={{ 'aria-label': 'Without label' }}
        >
            <MenuItem value={'yes'}>Yes</MenuItem>
            <MenuItem value={'no'}>No</MenuItem>
        </Select></FormControl>)
} 
